import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CALL_PRICES,

} from "./actionTypes"

import {
  getCallPricesSuccess,
  getCallPricesError,

} from "./actions"

import {

  genericGetRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

function* onGetCallPrices(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/call_prices`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCallPricesSuccess(response))
  } catch (error) {
    yield put(getCallPricesError(error))
  }
}


function* CallPricesSaga() {
  yield takeEvery(GET_CALL_PRICES, onGetCallPrices)


}

export default CallPricesSaga

